import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/useCategoryStore";
import { findActiveCategoryByUrlIds } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByUrlId";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { ICategoryTreeNodeMetadata } from "@faire/web-api--source/indigofair/data/ICategoryTreeNodeMetadata";
import { useMemo } from "react";

export const useIsHubCategory = (): {
  isHubCategory: boolean;
  isHubC1Subcategory: boolean;
} => {
  const categoryModel = useCurrentCategoryModel();
  const { categories } = useCategoryStore();
  const currentCategory = useMemo(
    () => findActiveCategoryByUrlIds(categoryModel.urlIdStrings, categories),
    [categories, categoryModel.urlIdStrings]
  );

  const c1UrlId = categoryModel.urlId.id;

  const currentC1Category = useMemo(
    () => findActiveCategoryByUrlIds([c1UrlId], categories),
    [c1UrlId, categories]
  );

  const currentC1IsHubCategory =
    currentC1Category?.tree_node_metadata?.category_group ===
    ICategoryTreeNodeMetadata.CategoryGroup.HUB;

  const currentCategoryIsSubcategory = categoryModel.subCategory !== undefined;

  return {
    isHubCategory:
      currentCategory?.tree_node_metadata?.category_group ===
      ICategoryTreeNodeMetadata.CategoryGroup.HUB,
    isHubC1Subcategory: currentC1IsHubCategory && currentCategoryIsSubcategory,
  };
};
